<template>
	<div class="page_6">		
		<div class="panel" :style="{backgroundImage: 'url(' + imgBg + ')'}">
			<h1>马上预约一次现场演示</h1>
			<div class="btn-group">
				<el-button type="primary" @click="dialogMap = true">查看地图位置</el-button>
				<el-button type="primary" @click="dialogInfo = true">获取DEMO</el-button>
			</div>
		</div>
		<div class="contact">
			<label>我们在这里</label>
			厦门市湖里区园山南路806号
			<span>|</span>
			<i class="iconfont icon-youxiang"></i>qlink@qlink.cc			
			<span>|</span>
			<i class="iconfont icon-shouji"></i>0592-8222272
			<i class="iconfont icon-weihu"></i>终身故障维护
			<i class="iconfont icon-liaotian"></i>7×24小时售后支持
			<i class="iconfont icon-mian"></i>软件永久免费
		</div>
		<foot></foot>
		<el-dialog v-model="dialogInfo" :show-close="false" :modal-append-to-body="false" size="small">
			<div>
				<h3>获取DEMO<small>想要预约一次现场演示，领取DEMO，请填写表格</small></h3>
				<el-form  :model="formData" :rules="formRules" ref="formData" label-width="100px">
					<el-form-item label="姓名" prop="name" required>
						<el-input v-model="formData.name" placeholder="姓名"></el-input>
					</el-form-item>
					<el-form-item label="手机"  prop="phone" required>
						<el-input v-model="formData.phone" placeholder="手机"></el-input>
					</el-form-item>
					<el-form-item label="公司名称"  prop="company" required>
						<el-input v-model="formData.company" placeholder="公司名称"></el-input>
					</el-form-item>
					<el-form-item label="需求" prop="demand" required>
						<el-input v-model="formData.demand" placeholder="需求"></el-input>
					</el-form-item>
					<el-form-item label-width="0">
						<el-button type="primary">查询</el-button>
						<el-button @click="dialogInfo=false">关闭</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		
		<el-dialog v-model="dialogMap" size="large" :show-close="false" :modal-append-to-body="false">
			<BMap></BMap>
		</el-dialog>
	</div>
</template>

<script>
	import foot from '@/modules/footer'
	import BMap from '@/modules/home/bmap.vue'
	export default {
		name: 'page_6',
		data() {
			return {
				imgBg:require("@/assets/img/home/map.png"),
				"dialogInfo":false,
				"dialogMap":false,
				"formData":{
					name:"",
					phone:"",
					company:"",
					demand:""
				},
				//登录框校验
					formRules: {
						name: [{
							trigger: 'blur',
							required: true,
							message:"请输入姓名"
						}],
						phone: [{
							trigger: 'blur',
							required: true,
							message:"请输入手机号"
						},{
							trigger: 'blur,change',
							validator: function(rule, value, callback){
								if(!/^1[34578]\d{9}$/.test(value)) {
									return callback("请输入正确的手机号")
							    } else {
									return callback();
								}
							},
						}],
						company: [{
							trigger: 'blur',
							required: true,
							message:"请输入公司名称"
						}],
						demand: [{
							trigger: 'blur',
							required: true,
							message:"请输入需求"
						}],
					}
			}
		},
		//计算数据
		computed: {
		},
		//参数数据
		props: {},
		//方法
		methods: {
			fnScroll:function(){
				if(this.dialogInfo){
					this.dialogInfo = false;
				}
				if(this.dialogMap){
					this.dialogMap = false;
				}
			}
		},
		//组件
		components: {
			foot,			
			BMap,
		},
		//生命周期-创建
		created() {},
		//生命周期-准备就绪
		mounted() {			
			window.onmousewheel = document.onmousewheel = this.fnScroll; //IE/Opera/Chrome
			if(document.attachEvent) {
				document.attachEvent('onmousewheel', this.fnScroll);
			} else if(document.addEventListener) {
				document.addEventListener('DOMMouseScroll', this.fnScroll, false);
			}
		},
		//监控变量
		watch: {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import url("../../assets/common.less");
	.page_6 {
		.page();
		width:100%;
		background-color:#212930;
		& > .panel{
			background-size: 100% 100%;
			height: 45vh;
			& > h1{
				position: absolute;
				text-align: center;
				top: 15vh;
				width: 100%;
				color: #DDDDDD;
			}
			& > .btn-group{
				position: absolute;
				width: 100%;
				text-align: center;
				top: 30vh;
				color: #DDD;
			}		
		}
		& > .contact{
			height: 15vh;
			font-size: 1vw;
			line-height: 15vh;
			color: #FFF;
			text-align: center;
			margin: 0 8vw;
			border-bottom: 1px solid #6a8ead;
			& > label:nth-of-type(1){
				padding-right:20px ;
				color:#6a8ead;
			}
			& > span{
				padding-left: 40px;
			}
			& >i{
				padding-left: 20px;
				padding-right: 5px;
			}
		
		}
		& > .v-modal{
			position: absolute;
		}
		& > .el-dialog__wrapper{
			position: absolute;
		}
		.el-dialog{
			.el-dialog__header{
				padding: 0;
				margin: 0;
			}
			.el-dialog__body{
				padding: 0;
				h3{
					text-align: center;
					font-size: 2em;
					color: @theme-color;
					padding: 50px;					
					small{
						display: block;
						padding: 0 20px;
						color: #777;
					}
				};
				.el-form-item{
					&:nth-of-type(1),
					&:nth-of-type(2){
						width: 60%;
					}
					&:nth-of-type(3),
					&:nth-of-type(4){
						width:80%; 
					}
					&:nth-last-of-type(1){
						text-align: center;
					}
					.el-button{
						width: 30%;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// page_6.vue?7c0be418